import { Quote } from 'lucide-react';
import { FadeIn } from '@/components/motion/FadeIn';
import { MaskReveal } from '@/components/motion/Reveal';

interface Testimonial {
  quote: string;
  author: string;
  role: string;
  company: string;
  avatar_media_id?: string;
  logo_media_id?: string;
}

interface Props {
  items: Testimonial[];
}

export function HomeTestimonials({ items }: Props) {
  if (!items || items.length === 0) return null;
  return (
    <MaskReveal className="section-y-lg" tilt={-1} duration={1.1}>
      <div className="container-wide">
        <FadeIn>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold-500">Testimonials</p>
          <h2 className="mt-3 text-h2 text-fg">What teams say about working with us.</h2>
        </FadeIn>
        <div className="mt-12 grid gap-6 md:grid-cols-3">
          {items.map((t, idx) => (
            <FadeIn key={`${t.author}-${idx}`} delay={idx * 0.05}>
              <figure className="h-full rounded-xl border border-border bg-bg-elevated/40 p-6">
                <Quote className="h-6 w-6 text-gold-500/60" />
                <blockquote className="mt-4 text-base leading-relaxed text-fg">{t.quote}</blockquote>
                <figcaption className="mt-6 flex items-center gap-3">
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-gold-500/10 text-gold-500">
                    {t.author?.[0]?.toUpperCase() ?? '?'}
                  </div>
                  <div>
                    <p className="text-sm font-semibold">{t.author}</p>
                    <p className="text-xs text-fg-subtle">
                      {t.role}
                      {t.company ? ` · ${t.company}` : ''}
                    </p>
                  </div>
                </figcaption>
              </figure>
            </FadeIn>
          ))}
        </div>
      </div>
    </MaskReveal>
  );
}